export class PartIdentifier {
  /**
   *
   * @param {{partNumber:number, drawingRevision:string, suffix:string}} part1
   * @param {{partNumber:number, drawingRevision:string, suffix:string}} part2
   * @returns {bool}
   */
  static compare = (part1, part2) => {
    return (
      part1.partNumber === part2.partNumber &&
      this.trimLeadingZeros(part1.drawingRevision)
        .toLocaleLowerCase()
        .localeCompare(
          this.trimLeadingZeros(part2.drawingRevision).toLocaleLowerCase()
        ) === 0 &&
      part1.suffix
        ?.toLocaleLowerCase()
        ?.localeCompare(part2.suffix?.toLocaleLowerCase()) === 0
    );
  };

  static buildPartIdentifier = (part) => {
    return {
      partNumber: part.Number.Fields[0],
      drawingRevision: part.DrawingRevision?.Fields[0]?.Fields[0] ?? "",
      suffix: part.Suffix?.Fields[0]?.Fields[0] ?? "",
    };
  };
  /**
   *
   * @param {string} s
   * @returns {string}
   */
  static trimLeadingZeros = (s) => {
    if (s) {
      return s.replace(/^0+/, "");
    } else {
      return "";
    }
  };
}
